module.exports = __webpack_public_path__ + "static/media/fold-finished.aedf0b85.png";